if (!customElements.get('tk-sticky-atc')) {
  customElements.define(
    'tk-sticky-atc',
    class TkStickyAtc extends HTMLElement {
      connectedCallback() {
        this.sectionId = this.dataset.sectionId;

        this.submitButton = this.querySelector('[data-sticky-add]');
        this.submitText = this.querySelector('[data-sticky-add-text]');
        this.spinner = this.submitButton?.querySelector('.loading__spinner');
        this.qtyValue = this.querySelector('[data-sticky-qty-value]');
        this.quantityWrap = this.querySelector('.tk-sticky-atc__quantity');
        this.priceEl = this.querySelector('[data-sticky-price]');
        this.variantEl = this.querySelector('[data-sticky-variant]');
        this.selectsWrap = this.querySelector('[data-sticky-selects]');
        this.thumb = this.querySelector('.tk-sticky-atc__img');

        this.mainQtyInput = document.getElementById(`Quantity-${this.sectionId}`);
        this.mainMinus = document.querySelector(`#Quantity-Form-${this.sectionId} .quantity__button[name="minus"]`);
        this.mainPlus = document.querySelector(`#Quantity-Form-${this.sectionId} .quantity__button[name="plus"]`);
        this.mainSubmit = document.getElementById(`ProductSubmitButton-${this.sectionId}`);

        this.setupVisibility();
        this.setupQuantity();
        this.setupAdd();
        this.setupVariantSelects();
        this.setupAvailabilityObserver();

        this.subscriptions = [
          subscribe(PUB_SUB_EVENTS.variantChange, this.onVariantChange.bind(this)),
          subscribe(PUB_SUB_EVENTS.cartUpdate, this.stopLoading.bind(this)),
          subscribe(PUB_SUB_EVENTS.cartError, this.stopLoading.bind(this)),
        ];

        this.syncQuantity();
        this.syncAvailability();
      }

      disconnectedCallback() {
        this.observer?.disconnect();
        this.availabilityObserver?.disconnect();
        this.subscriptions?.forEach((unsub) => unsub());
        if (this.loadingTimeout) clearTimeout(this.loadingTimeout);
      }

      setupVisibility() {
        if (!this.mainSubmit) return;
        this.observer = new IntersectionObserver(
          (entries) => {
            // Ultima entry del batch: il giro focus Dawn + restore scroll produce
            // due crossing nello stesso callback e entries[0] sarebbe stantia.
            const entry = entries[entries.length - 1];
            // Solo quando l'ATC principale e' sopra il viewport, non sotto la piega al load.
            const show = !entry.isIntersecting && entry.boundingClientRect.top < 0;
            this.toggle(show);
          },
          { threshold: 0 },
        );
        this.observer.observe(this.mainSubmit);
      }

      toggle(show) {
        this.classList.toggle('is-visible', show);
        this.toggleAttribute('inert', !show);
      }

      setupQuantity() {
        if (!this.mainQtyInput || !this.mainMinus || !this.mainPlus) {
          this.quantityWrap?.remove();
          return;
        }
        this.querySelector('[data-sticky-qty="minus"]')?.addEventListener('click', () => {
          this.mainMinus.click();
        });
        this.querySelector('[data-sticky-qty="plus"]')?.addEventListener('click', () => {
          this.mainPlus.click();
        });
        this.mainQtyInput.addEventListener('change', this.syncQuantity.bind(this));
      }

      syncQuantity() {
        if (this.mainQtyInput && this.qtyValue) {
          this.qtyValue.textContent = this.mainQtyInput.value;
        }
      }

      setupAdd() {
        this.submitButton?.addEventListener('click', () => {
          if (this.submitButton.disabled || this.submitButton.getAttribute('aria-disabled') === 'true') return;
          this.startLoading();
        });
      }

      setupAvailabilityObserver() {
        if (!this.mainSubmit) return;
        // Su combo inesistente Dawn chiama setUnavailable() senza pubblicare
        // variantChange: il pub/sub da solo lascerebbe la CTA sticky attiva.
        this.availabilityObserver = new MutationObserver(this.syncAvailability.bind(this));
        this.availabilityObserver.observe(this.mainSubmit, {
          attributes: true,
          attributeFilter: ['disabled', 'aria-disabled'],
        });
      }

      setupVariantSelects() {
        if (!this.selectsWrap) return;
        // Listener delegato: sopravvive allo swap innerHTML di syncVariantSelects.
        this.selectsWrap.addEventListener('change', (event) => {
          const select = event.target.closest('[data-sticky-select]');
          if (!select) return;
          const optionValueId = select.selectedOptions[0]?.dataset.optionValueId;
          if (!optionValueId) return;
          const radio = document.querySelector(
            `#variant-selects-${this.sectionId} input[type="radio"][data-option-value-id="${optionValueId}"]`,
          );
          if (radio && !radio.checked) radio.click();
        });
      }

      syncVariantSelects(html) {
        if (!this.selectsWrap) return;
        const fresh = html?.querySelector('[data-sticky-selects]');
        if (!fresh) return;
        const focusedId = this.selectsWrap.contains(document.activeElement)
          ? document.activeElement.id
          : null;
        const scrollY = window.scrollY;
        this.selectsWrap.innerHTML = fresh.innerHTML;
        if (!focusedId) return;
        // Dawn rifocalizza il radio del picker in un microtask dopo il re-render,
        // scrollando la pagina al picker: il macrotask riprende focus e scroll
        // solo quando il cambio è partito dallo sticky.
        setTimeout(() => {
          window.scrollTo({ top: scrollY });
          document.getElementById(focusedId)?.focus({ preventScroll: true });
        });
      }

      startLoading() {
        this.submitButton.classList.add('loading');
        this.submitButton.setAttribute('aria-disabled', 'true');
        this.spinner?.classList.remove('hidden');
        if (this.loadingTimeout) clearTimeout(this.loadingTimeout);
        this.loadingTimeout = setTimeout(() => this.stopLoading(), 10000);
      }

      stopLoading() {
        if (this.loadingTimeout) clearTimeout(this.loadingTimeout);
        this.submitButton.classList.remove('loading');
        this.submitButton.removeAttribute('aria-disabled');
        this.spinner?.classList.add('hidden');
      }

      onVariantChange(event) {
        if (event.data.sectionId !== this.sectionId) return;
        const variant = event.data.variant;

        const newPrice = event.data.html?.getElementById(`price-${this.sectionId}`);
        if (this.priceEl && newPrice) {
          this.priceEl.innerHTML = newPrice.innerHTML;
        }

        if (this.variantEl && variant) {
          this.variantEl.textContent = variant.title;
        }

        this.syncVariantSelects(event.data.html);

        const src = variant?.featured_media?.preview_image?.src || variant?.featured_image?.src;
        if (src && this.thumb) {
          this.thumb.src = `${src}${src.includes('?') ? '&' : '?'}width=240`;
          this.thumb.removeAttribute('srcset');
          this.thumb.removeAttribute('sizes');
        }

        this.syncAvailability();
      }

      syncAvailability() {
        if (!this.mainSubmit || !this.submitButton) return;
        const disabled =
          this.mainSubmit.hasAttribute('disabled') ||
          this.mainSubmit.getAttribute('aria-disabled') === 'true';
        this.submitButton.disabled = disabled;
        if (this.submitText) {
          const mainLabel = this.mainSubmit.querySelector('span')?.textContent.trim();
          this.submitText.textContent = disabled
            ? mainLabel || this.submitButton.dataset.labelSoldout
            : this.submitButton.dataset.labelDefault;
        }
      }
    },
  );
}
